import { createSelector } from '@ngrx/store';
import { getStorePageState } from '../store.selectors';

export const getStoreVariationsState = createSelector(
  getStorePageState,
  (state) => state.variationsState
);
export const getStoreVariationsIsLoading = createSelector(
  getStoreVariationsState,
  (variations) => variations.isLoading
);
export const getStoreVariationsData = createSelector(
  getStoreVariationsState,
  (variations) => variations.data
);
export const getStoreVariationsHasBeenFetched = createSelector(
  getStoreVariationsState,
  (variations) => variations.fetched
);
export const getStoreVariationsError = createSelector(
  getStoreVariationsState,
  (variations) => variations.error
);
export const getStoreVariationsSuccess = createSelector(
  getStoreVariationsState,
  (variations) => variations.success
);
